// Shared helper for reading a value out of a game definition's own
// configRows (see app.js's renderConfigRows/getConfigRowValues, which build
// the actual setup-screen UI from this same data). Every row's `default`
// is stored as a string, same as every option's `value` - `numeric: true`
// on the row is what tells a caller who needs an actual Number (e.g. lives,
// darts totals) to convert it back, instead of every reader duplicating
// that check.
export function configRowDefault(definition, rowId) {
    const row = (definition.configRows || []).find(r => r.id === rowId);
    if (!row) return undefined;
    return row.numeric ? Number(row.default) : row.default;
}
